import { CountryCode } from '@olxpwa-lib/i18n/types';
import { AppEnvironment } from '~types';

export enum APIPath {
    Atlas = 'api',
    AtlasV1 = 'api/v1',
    AtlasV2 = 'api/v2',
    BookingV2 = 'booking/api/v2',
    BookingV3 = 'booking/api/v3',
    ServiceFeature = 'sfc/api/v1'
}

export const getBaseApiUrl = (
    env: AppEnvironment,
    countryCode: CountryCode,
    APIPathName?: (typeof APIPath)[keyof typeof APIPath]
) => {
    const country = countryCode.toLowerCase();
    const ApiPath = APIPathName ? APIPathName : '';

    switch (env) {
        case AppEnvironment.Development:
        case AppEnvironment.Staging:
            return `https://www.${country}.stg.eu.olx.org/${ApiPath}`;
        default:
            return `https://www.olx.${country}/${ApiPath}`;
    }
};
